import React from 'react'
import { motion } from 'framer-motion'

import { projects } from '../../Constants'
import { fadeIn, textVariant } from '../../utils/motion'

import Magazines from '../../Magazines/Magazines'
import ProjectCard from './ProjectCard'

const Work = () => {
  return (
    <>
      <motion.div className='mt-32 px-2' variants={textVariant()}>
        <p className='sm:text-[18px] text-[14px] dark:text-secondary tracking-wider uppercase font-medium text-primary'>
          My work.
        </p>
        <h2 className='text-[#915eff] dark:text-white font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]'>
          Projects.
        </h2>
      </motion.div>
      <motion.p
        variants={fadeIn('', '', 0.1, 1)}
        className='mt-4 dark:text-secondary text-gray-500 text-[17px] max-w-3xl leading-[30px] px-2.5'
      >
        Following projects showcase my skill and experience through real-world
        examples of my work. Each project is briefly described with links to
        code repositories and live demos in it. It reflects my ability to solve
        complex problems, work with different technologies, and manage project
        efficiently.
      </motion.p>

      <section className='mt-20 flex flex-row flex-wrap gap-10 '>
        {projects.map((project, index) => (
          <ProjectCard key={`project-${index} `} index={index} {...project} />
        ))}
      </section>
    </>
  )
}

export default Magazines(Work, 'work')
